import { Component, model } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { MailStatutLibelle } from '../../../../../../../../data/mail/models/mail-statuts.model';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { Chip } from 'primeng/chip';

@Component({
    selector: 'infos-statuts',
    templateUrl: './infos-statuts.component.html',
    styleUrls: ['./infos-statuts.component.scss'],
    imports: [Dialog, TableModule, TranslateModule, NgClass, Chip],
    standalone: true
})
export class InfosStatutsComponent {
    /**
     * Signals
     */
    visible = model(false);

    /**
     * Properties
     */
    columns = [
        { field: 'statut', label: 'page.emails.statut', width: '20%' },
        { field: 'description', label: 'page.emails.description', width: '45%' },
        { field: 'action', label: 'page.emails.action', width: '35%' }
    ];

    rows = [
        {
            color: 'grey',
            statut: MailStatutLibelle.request,
            description: 'page.emails.request',
            action: []
        },
        {
            color: 'grey',
            statut: MailStatutLibelle.deferred,
            description: 'page.emails.deferred',
            action: []
        },
        {
            color: 'green',
            statut: MailStatutLibelle.delivered,
            description: 'page.emails.delivered',
            action: ['page.emails.delivered-action']
        },
        {
            color: 'red',
            statut: MailStatutLibelle.invalid_email,
            description: 'page.emails.invalid-email',
            action: ['page.emails.invalid-email-action']
        },
        {
            color: 'red',
            statut: MailStatutLibelle.blocked,
            description: 'page.emails.blocked',
            action: ['page.emails.blocked-action']
        },
        {
            color: 'red',
            statut: MailStatutLibelle.soft_bounce,
            description: 'page.emails.soft-bounce',
            action: []
        },
        {
            color: 'red',
            statut: MailStatutLibelle.hard_bounce,
            description: 'page.emails.hard-bounce',
            action: ['page.emails.hard-bounce-action-1', 'page.emails.hard-bounce-action-2']
        },
        {
            color: 'red',
            statut: MailStatutLibelle.spam,
            description: 'page.emails.spam',
            action: ['page.emails.spam-action']
        },
        {
            color: 'red',
            statut: MailStatutLibelle.error,
            description: 'page.emails.error',
            action: []
        }
    ];
}
